export default __webpack_public_path__ + "static/media/TtLogoW.90a07ea6.png";